/* eslint-disable react/prop-types */
import { createContext, useContext, useState, useEffect, useMemo } from "react";
import admin from "../Controllers/admin";
import usePathologyData from "../Hooks/UsePathologyData";

const PathologyContext = createContext();

export const PathologyProvider = ({ children }) => {
  const { pathologyData, pathologyLoading, pathologyError } =
    usePathologyData(true);

  const [selectedPathology, setSelectedPathology] = useState(() => {
    const stored = localStorage.getItem("selectedPathology");
    return stored ? JSON.parse(stored) : null;
  });

  // Map for instant lookup
  const pathologyMap = useMemo(() => {
    if (!pathologyData) return {};
    const map = {};
    pathologyData.forEach((p) => (map[p.id] = p));
    return map;
  }, [pathologyData]);

  // Auto assign clinic for pathologist role
  useEffect(() => {
    const role = admin?.role?.name?.toLowerCase();
    if (role === "pathologist" && pathologyMap[admin.pathologist_id]) {
      setSelectedPathology(pathologyMap[admin.pathologist_id]);
    } else {
      localStorage.removeItem(selectedPathology);
    }
  }, [pathologyMap]);

  // Save to localStorage
  useEffect(() => {
    const role = admin?.role?.name?.toLowerCase();
    if (role !== "pathologist") {
      localStorage.removeItem("selectedPathology");
    }
    
  }, [selectedPathology]);

  return (
    <PathologyContext.Provider
      value={{
        pathologyData,
        pathologyLoading,
        pathologyError,
        selectedPathology,
        setSelectedPathology,
        pathologyMap,
      }}
    >
      {children}
    </PathologyContext.Provider>
  );
};

// Custom hook to use context
// eslint-disable-next-line react-refresh/only-export-components
export const useSelectedPathology = () => {
  return useContext(PathologyContext);
};
